import { render } from "./AppColorMask.vue?vue&type=template&id=5a1327e4&scoped=true&ts=true"
import script from "./AppColorMask.vue?vue&type=script&lang=ts"
export * from "./AppColorMask.vue?vue&type=script&lang=ts"

import "./AppColorMask.vue?vue&type=style&index=0&id=5a1327e4&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a1327e4"]])

export default __exports__